import {RootState} from '../../rootReducer';
import {AnnouncementDto} from '@lib/infrastructure';
import {createSelector} from 'reselect';

export const selectEmployeeCommunicationAnnouncements = (state: RootState) =>
  state.data.employeeCommunication.announcements;
export const selectEmployeeCommunicationLoadingStatus = (state: RootState) =>
  state.data.employeeCommunication.loadingStatus;

export const selectAllMeetingSuggestionsWithOrganizerAttendees = createSelector(
  // Good luck figuring out why the test brakes
  // when using `getAllWorkspaceReservations` the test fails with
  // `createSelector expects all input-selectors to be functions, but received the following types: [function wrappedSelector(), undefined, function unnamed()]`
  (state: RootState) => Object.values(state.data.timeslots.workdaysByDate).flatMap((e) => e?.data ?? []),
  (state: RootState) => Object.values(state.data.timeslots.workspaceReservationsByDate).flatMap((e) => e?.data ?? []),
  (state: RootState) => state.data.employeeCommunication.announcements,
  (workdays, workspaceReservations, announcements) => {
    const filteredAnnouncements: AnnouncementDto[] = [];

    for (const announcement of announcements) {
      const {targetType} = announcement.targetFilter;

      if (targetType === 'DefaultBuilding') {
        continue;
      }

      if (targetType === 'All') {
        filteredAnnouncements.push(announcement);
        continue;
      }

      if (targetType === 'WorkingLocation') {
        const {buildingId, floorId, areaId} = announcement.targetFilter;

        if (buildingId && !floorId) {
          const hasMatchingWorkdays = workdays.some((workday) => {
            if (workday.status !== 'OfficeDay' || buildingId !== workday.buildingId) return false;

            if (announcement.endDateTimeLocal < workday.localStart) return false;
            if (announcement.startDateTimeLocal > workday.localEnd) return false;

            return true;
          });

          if (hasMatchingWorkdays) {
            filteredAnnouncements.push(announcement);
            continue;
          }
        } else {
          const hasMatchingWorkspaceReservations = workspaceReservations.some((workspaceReservation) => {
            const {workspace} = workspaceReservation;

            if (buildingId !== workspace.buildingId) return false;
            if (floorId && (!('floorId' in workspace) || workspace.floorId !== floorId)) return false;
            if (areaId && (!('areaId' in workspace) || workspace.areaId !== areaId)) return false;

            if (announcement.endDateTimeLocal < workspaceReservation.localStart) return false;
            if (announcement.startDateTimeLocal > workspaceReservation.localEnd) return false;

            return true;
          });

          if (hasMatchingWorkspaceReservations) {
            filteredAnnouncements.push(announcement);
            continue;
          }
        }

        continue;
      }
    }

    return filteredAnnouncements;
  },
);
